/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const CrashDateTimePrecision = {
    Exact: 'Exact',
    Hour: 'Hour',
    Month: 'Month'
};
export function CrashDateTimePrecisionFromJSON(json) {
    return CrashDateTimePrecisionFromJSONTyped(json, false);
}
export function CrashDateTimePrecisionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CrashDateTimePrecisionToJSON(value) {
    return value;
}
